import React, {Fragment, useEffect, useState} from "react";
import Breadcrumb from "../../../layout/breadcrumb";
import {Card, CardBody, Col, Container, Form, FormGroup, Input, Row} from "reactstrap";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import reportReducer from "../index";
import withReducer from "../../../store/withReducer";
import {useDispatch, useSelector} from "react-redux";
import exchangeOrder, {getExchangeOrderReportData, selectExchangeOrderReport} from "./store/exchangeOrderSlice";
import moment from "moment";
import Select from "react-select";
import {getCustomerList, setCustomers} from "../../backInStock/store/backStockSlice";
import AsyncSelect from "react-select/async";
import {mapSearchAutoSuggestion} from "../../../utils/mapper";
import {sellerAutoSuggestionApi} from "../../../services/manage-product/productService";

const dataMenu = [
    {
        type: 0,
        text: 'Exchange Order Report',
    }
];

const customStyles = {
    control: base => ({
        ...base,
        minHeight: 50,
        border: 'none',
    })
};

const ExchangeOrder = () =>{

    const dispatch = useDispatch();
    const [page,setPage]=useState(0);
    const authData =  useSelector(({authReducer}) => authReducer);
    const exchangeOrderReport = useSelector(selectExchangeOrderReport);
    const exchangeOrderState = useSelector(({report})=> report.exchangeOrder);
    const [pageSize, setPageSize] = useState(10);
    const [tableLoading, isSetTableLoading] = useState(false);
    const [name, setName] = useState(null);
    const [customer, setCustomer] = useState(null);
    const TodayDate=new Date();
    const sevenDays=new Date().setDate(TodayDate.getDate()-30);
    const [dateRange, setDateRange] = useState([ sevenDays,TodayDate]);
    const [loading, isSetLoading] = useState(false);
    const userState =  useSelector(({authReducer}) => authReducer.data);
    const backInRequestState = useSelector(({backStore}) => backStore.backStoreRequest);
    // const [seller, setSeller] = useState(null);
    const [seller, setSeller] = useState(authData.defaultSeller);

    const [startDate, endDate] = dateRange;

    const tableColumns = [
        {
            name: 'Order ID',
            selector: row => row.old_order_id,
            sortable: true,
            center: false,
        },
        {
            name: 'Old Order ID',
            selector: row => row.order_id,
            sortable: true,
            center: false,
        },
        {
            name: 'Product',
            selector: row => row.product,
            sortable: true,
            center: false,
        },
        {
            name: 'Seller',
            selector: row => row.seller,
            sortable: true,
            center: false,
        },
        {
            name: 'Customer',
            selector: row => row.customer,
            sortable: true,
            center: false,
        },
        {
            name: 'Quantity',
            selector: row => row.qty,
            sortable: true,
            center: true,
        },
        {
            name: 'Exchange Date',
            selector: row => row.exchange_date,
            sortable: true,
            center: false,
        },
    ];

    useEffect(()=>{
        setSeller(authData.defaultSeller)
    },[authData.defaultSeller])

    useEffect(() => {
        getData();
    },[startDate, endDate,page, pageSize,dispatch, name,customer,seller]);

    useEffect(()=>{
        dispatch(getCustomerList()).then(res => {
            dispatch(setCustomers(res.payload))
        });
    },[dispatch])

    const getData = () => {
        if(startDate!==null && endDate!==null) {
            isSetTableLoading(true);
            const data = {
                name,
                page: page,
                customer,
                // seller,
                seller: seller && seller.value ? seller.value : '',
                pageSize: 10,
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
            };
            dispatch(getExchangeOrderReportData(data)).then(res => {
                if(!res.error){
                    isSetLoading(false);
                }
                isSetTableLoading(false);
            });
        }
    };

    const pagination = (e) => {
        setPageSize(e)
    }

    const sellerPromiseOption = (inputValue) =>
        new Promise((resolve) => {
            const data = {
                value: inputValue
            }
            setTimeout(() => {
                resolve(mapSearchAutoSuggestion(sellerAutoSuggestionApi(data)))
            });
        });

    return (
        <Fragment>
            <Breadcrumb title="Exchange Order Report" data={dataMenu}/>
            <Container fluid={true} className="product-wrapper">
                <div className="product-grid">
                    <div className="feature-products">
                        <Row>
                            <Col sm={4}>
                                <Form>
                                    <FormGroup className="m-0">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            onChange={(e)=>{setName(e.target.value)}}
                                            placeholder="Search Order"
                                        />
                                        <i className="fa fa-search"></i>
                                    </FormGroup>
                                </Form>
                            </Col>
                            <Col sm={4}>
                                <AsyncSelect
                                    className="select2-filter"
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                    defaultOptions
                                    placeholder="select Seller"
                                    loadOptions={sellerPromiseOption}
                                    styles={{...customStyles, menuPortal: base => ({ ...base, zIndex: 100 }) }}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                    onClear={(e) => {

                                    }}
                                    value={seller}
                                    onChange={(e) => {
                                        setSeller(e);
                                        // setSeller(e ? e.value : null);

                                    }}

                                />
                            </Col>
                            <Col sm={4}>
                                <Select
                                    placeholder={<div>Customer</div>}
                                    className="select2-filter"
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.uid}
                                    isClearable
                                    // cacheOptions
                                    styles={customStyles}
                                    // defaultValue={backInRequestState.filter.country}
                                    options={backInRequestState.customers}
                                    onChange={(e) => {
                                        setCustomer(e ? e.uid : null);
                                    }}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}

                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col className="mt-4" sm="12">
                                <Card>
                                    <CardBody>
                                        <div className="table-responsive product-table">
                                            <CommonDataTable
                                                noAction
                                                headerColumns={tableColumns}
                                                gridData={exchangeOrderReport}
                                                paginationTotalRows={exchangeOrderState.exchangeOrderReportTableRow}
                                                paginationComponentOptions={{
                                                    noRowsPerPage: true
                                                }}
                                                paginationPerPage={10}
                                                paginationServer
                                                onChangePage={page => setPage(page)}
                                            />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>
        </Fragment>
    );
}

export default withReducer ([{report: reportReducer}]) (ExchangeOrder);